var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPf = function SvgIconPf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.459 6.262h21.082A12 12 0 0 0 12 0C7.45 0 3.494 2.53 1.459 6.26M12 24c4.548 0 8.506-2.53 10.54-6.261H1.46a12 12 0 0 0 10.54 6.26"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M16.174 12c0 2.305-1.869 3.652-4.174 3.652S7.826 14.305 7.826 12a4.174 4.174 0 1 1 8.348 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M16.174 12a4.174 4.174 0 0 1-8.348 0"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.435 10.956H9.392v2.087h1.043zM14.609 10.956h-1.044v2.087h1.044zM12.522 9.39h-1.043v3.653h1.043z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconPf;